var base = require('settings/security/enable-two-factor-auth');

Vue.component('spark-enable-two-factor-auth', {
    mixins: [base]
});



// WEBPACK FOOTER //
// ./resources/js/spark-components/settings/security/enable-two-factor-auth.js